import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { LorenLayerSelectionComponent } from "./components/loren-layer-selection/loren-layer-selection.component";
import { LorenLayersSelectionDialogModule } from "../loren-layers-selection-dialog/loren-layers-selection-dialog.module";

@NgModule({
  declarations: [LorenLayerSelectionComponent],
  exports: [LorenLayerSelectionComponent],
  imports: [
    CommonModule,
    MatIconModule,
    LorenLayersSelectionDialogModule,
    MatButtonModule,
  ],
})
export class LorenLayerSelectionModule {}
